<template>
    <div class="projectServicesTop">
        <div class="projectServicesImg">
            <div class="projectServicesContent">
                <div class="projectServicesList">
                    <div
                        class="projectServicesItem"
                        @mouseenter="addStyle"
                        @mouseleave="moveStyle"
                        @click="changRoutes(0)"
                    >
                        建华要闻
                    </div>
                    <div
                        class="projectServicesItem"
                        @mouseenter="addStyle"
                        @mouseleave="moveStyle"
                        @click="changRoutes(1)"
                    >
                        合作交流
                    </div>
                    <div
                        class="projectServicesItem"
                        @mouseenter="addStyle"
                        @mouseleave="moveStyle"
                        @click="changRoutes(2)"
                    >
                        员工风采
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import $ from "jquery";
export default {
    name: "ProjectServicesTop",
    mounted() {
        this.setAction();
    },
    methods: {
        setAction() {
            let now = this.$route.path.split("/");
            now = now[now.length - 1];
            if (now == "detail") {
                let params = JSON.parse(sessionStorage.getItem("params"))
                    .menuCategory;
                let num = this.$route.params.menuCategory || params;
                switch (num) {
                    case 170:
                        $(".projectServicesItem").eq(0).addClass("activeStyle");
                        break;
                    case 180:
                        $(".projectServicesItem").eq(1).addClass("activeStyle");
                        break;
                    case 190:
                        $(".projectServicesItem").eq(2).addClass("activeStyle");
                        break;
                }
            } else if (now == "mediaAttention") {
                $(".projectServicesItem").eq(0).addClass("activeStyle");
            } else if (now == "coperationAndCommunication") {
                $(".projectServicesItem").eq(1).addClass("activeStyle");
            } else if (now == "staffPresence") {
                $(".projectServicesItem").eq(2).addClass("activeStyle");
            }
        },
        addStyle(e) {
            $(".projectServicesItem").removeClass("activeStyle");
            $(e.target).addClass("activeStyle");
        },
        moveStyle() {
            $(".projectServicesItem").removeClass("activeStyle");
            this.setAction();
        },
        changRoutes(num) {
            switch (num) {
                case 0:
                    this.$router.push({
                        path: "/newsCenter/mediaAttention",
                    });
                    break;
                case 1:
                    this.$router.push({
                        path: "/newsCenter/coperationAndCommunication",
                    });
                    break;
                case 2:
                    this.$router.push({
                        path: "/newsCenter/staffPresence",
                    });
                    break;
            }
        },
    },
};
</script>
<style lang="less" scoped>
.projectServicesTop {
    width: 100%;
    .projectServicesImg {
        width: 100%;
        height: 420px;
        background: url("../assets/newsCenter/banner.png");
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
        position: relative;
        .projectServicesContent {
            position: absolute;
            left: 0;
            bottom: 0;
            background-color: rgba(255, 255, 255, 0.8);
            width: 100%;
            .projectServicesList {
                margin: 0 auto;
                max-width: 1100px;
                display: flex;
                align-items: center;
                justify-content: center;
                .projectServicesItem {
                    cursor: pointer;
                    font-size: 16px;
                    letter-spacing: 1px;
                    color: #333;
                    padding: 17px 28px;
                }
                .activeStyle {
                    background-color: #0052d9;
                    color: #fff;
                    font-weight: bold;
                }
            }
        }
    }
}
</style>